<template>
    <div class="modals">
        <div class="modals-inner">
            <h2 class="modals-inner-title">ამანათის დეტალები</h2>
            <button class="modals-inner-closer" @click="emit('close')">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12.121"
                    height="12.121"
                    viewBox="0 0 12.121 12.121"
                >
                    <g
                        id="close-circle"
                        transform="translate(-244.109 -260.109)"
                    >
                        <path
                            id="Vector"
                            d="M0,10,10,0"
                            transform="translate(245.17 261.17)"
                            fill="none"
                            stroke="#12202b"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                        />
                        <path
                            id="Vector-2"
                            data-name="Vector"
                            d="M10,10,0,0"
                            transform="translate(245.17 261.17)"
                            fill="none"
                            stroke="#12202b"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                        />
                    </g>
                </svg>
            </button>

            <div class="modals-content">
                <div
                    class="item-info d-flex justify-content-between align-items-center"
                >
                    <div class="d-flex">
                        <div class="icon">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z"
                                    stroke="#fff"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5"
                                    stroke="#fff"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M8 13H12"
                                    stroke="#fff"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M8 17H16"
                                    stroke="#fff"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>

                        <div class="name">
                            <span>ინვოისი</span>
                            <p v-if="this.parcel.weight_price">
                                {{ this.parcel.weight_price }} ₾
                            </p>
                            <p v-else>0.00 ₾</p>
                        </div>
                    </div>
                    <a
                        :href="`/invoice/${this.parcel.id}`"
                        target="_blank"
                        v-if="this.parcel.payment_status"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            xmlns:svgjs="http://svgjs.com/svgjs"
                            width="20"
                            height="20"
                            x="0"
                            y="0"
                            viewBox="0 0 128 128"
                            style="enable-background: new 0 0 512 512"
                            xml:space="preserve"
                            class=""
                        >
                            <g>
                                <path
                                    xmlns="http://www.w3.org/2000/svg"
                                    id="Download"
                                    d="m128 65c0 15.439-12.563 28-28 28h-20c-2.211 0-4-1.791-4-4s1.789-4 4-4h20c11.027 0 20-8.973 20-20s-8.973-20-20-20h-4c-2.211 0-4-1.791-4-4 0-15.439-12.563-28-28-28s-28 12.561-28 28c0 2.209-1.789 4-4 4h-4c-11.027 0-20 8.973-20 20s8.973 20 20 20h20c2.211 0 4 1.791 4 4s-1.789 4-4 4h-20c-15.437 0-28-12.561-28-28s12.563-28 28-28h.223c1.996-17.975 17.277-32 35.777-32s33.781 14.025 35.777 32h.223c15.438 0 28 12.561 28 28zm-50.828 37.172-9.172 9.172v-50.344c0-2.209-1.789-4-4-4s-4 1.791-4 4v50.344l-9.172-9.172c-1.563-1.563-4.094-1.563-5.656 0s-1.563 4.094 0 5.656l16 16c.781.781 1.805 1.172 2.828 1.172s2.047-.391 2.828-1.172l16-16c1.563-1.563 1.563-4.094 0-5.656s-4.094-1.563-5.656 0z"
                                    fill="#000000"
                                    data-original="#000000"
                                    class=""
                                ></path>
                            </g>
                        </svg>
                    </a>
                </div>
                <div class="item-info">
                    <div class="icon">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M3.17004 7.43994L12 12.5499L20.77 7.46991"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                            <path
                                d="M12 21.6099V12.5399"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                            <path
                                d="M9.92999 2.48L4.59 5.45003C3.38 6.12003 2.39001 7.80001 2.39001 9.18001V14.83C2.39001 16.21 3.38 17.89 4.59 18.56L9.92999 21.53C11.07 22.16 12.94 22.16 14.08 21.53L19.42 18.56C20.63 17.89 21.62 16.21 21.62 14.83V9.18001C21.62 7.80001 20.63 6.12003 19.42 5.45003L14.08 2.48C12.93 1.84 11.07 1.84 9.92999 2.48Z"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                            <path
                                d="M17 13.24V9.58002L7.51001 4.09998"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                        </svg>
                    </div>
                    <div class="name">
                        <span>თრექინგი</span>
                        <p>{{ this.parcel.tracking_number }}</p>
                    </div>
                </div>

                <div class="item-info" v-if="this.parcel.barcode">
                    <div class="icon">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M3.17004 7.43994L12 12.5499L20.77 7.46991"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                            <path
                                d="M12 21.6099V12.5399"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                            <path
                                d="M9.92999 2.48L4.59 5.45003C3.38 6.12003 2.39001 7.80001 2.39001 9.18001V14.83C2.39001 16.21 3.38 17.89 4.59 18.56L9.92999 21.53C11.07 22.16 12.94 22.16 14.08 21.53L19.42 18.56C20.63 17.89 21.62 16.21 21.62 14.83V9.18001C21.62 7.80001 20.63 6.12003 19.42 5.45003L14.08 2.48C12.93 1.84 11.07 1.84 9.92999 2.48Z"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                            <path
                                d="M17 13.24V9.58002L7.51001 4.09998"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                        </svg>
                    </div>
                    <div class="name">
                        <span>ბარკოდი</span>
                        <p>{{ this.parcel.barcode }}</p>
                    </div>
                </div>

                <div class="item-info">
                    <div class="icon">
                        <img src="/images/airplane.svg" alt="" />
                    </div>
                    <div class="name">
                        <span>რეისი</span>
                        <p v-if="this.parcel.flight">
                            {{ this.parcel.flight.flight_id }}
                        </p>
                        <p v-else>-</p>
                    </div>
                </div>
                <div class="item-info">
                    <div class="icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                        >
                            <g id="weight" transform="translate(-236 -316)">
                                <path
                                    id="Vector"
                                    d="M7,20h4c5,0,7-2,7-7V7c0-5-2-7-7-7H7C2,0,0,2,0,7v6C0,18,2,20,7,20Z"
                                    transform="translate(239 318)"
                                    fill="none"
                                    stroke="#fff"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                />
                                <path
                                    id="Vector-2"
                                    data-name="Vector"
                                    d="M10.5,2A7.905,7.905,0,0,0,0,2l2.18,3.5a4.613,4.613,0,0,1,6.14,0Z"
                                    transform="translate(242.75 322.295)"
                                    fill="none"
                                    stroke="#fff"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="1.5"
                                />
                                <path
                                    id="Vector-3"
                                    data-name="Vector"
                                    d="M0,0H24V24H0Z"
                                    transform="translate(236 316)"
                                    fill="none"
                                    opacity="0"
                                />
                            </g>
                        </svg>
                    </div>
                    <div class="name">
                        <span>ამანათის წონა</span>
                        <p v-if="this.parcel.weight">
                            {{ parsWeight(this.parcel.weight) }}
                        </p>
                        <p v-else>0.00</p>
                    </div>
                </div>

                <div class="item-info">
                    <div class="icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                        >
                            <g id="location" transform="translate(-428 -188)">
                                <path
                                    id="Vector"
                                    d="M6.24,3.12A3.12,3.12,0,1,1,3.12,0,3.12,3.12,0,0,1,6.24,3.12Z"
                                    transform="translate(436.88 195.19)"
                                    fill="none"
                                    stroke="#fff"
                                    stroke-width="1.5"
                                />
                                <path
                                    id="Vector-2"
                                    data-name="Vector"
                                    d="M.243,6.49c1.97-8.66,14.8-8.65,16.76.01,1.15,5.08-2.01,9.38-4.78,12.04a5.193,5.193,0,0,1-7.21,0C2.253,15.88-.907,11.57.243,6.49Z"
                                    transform="translate(431.377 190)"
                                    fill="none"
                                    stroke="#fff"
                                    stroke-width="1.5"
                                />
                                <path
                                    id="Vector-3"
                                    data-name="Vector"
                                    d="M0,0H24V24H0Z"
                                    transform="translate(452 212) rotate(180)"
                                    fill="none"
                                    opacity="0"
                                />
                            </g>
                        </svg>
                    </div>
                    <div class="name">
                        <span>ფილიალი</span>
                        <p>
                            {{ this.parcel.city.title }},
                            {{ this.parcel.branch.name }}
                        </p>
                    </div>
                </div>

                <button
                    type="submit"
                    v-if="pageId != 4"
                    class="calculator-button"
                    @click="
                        () => {
                            emit('close');
                            emit('declaration');
                        }
                    "
                >
                    დეკლარირება
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref } from "@vue/composition-api";
import { useParcels } from "../../hooks/parcels";
export default defineComponent({
    props: {
        parcel: {
            type: Object,
            default: null,
        },
    },
    setup(props, { emit }) {
        const { pageId } = useParcels();

        const parsWeight = (weight) => {
            return Number(weight).toFixed(3);
        };
        return {
            props,
            emit,
            pageId,
            parsWeight,
        };
    },
});
</script>
